// @flow
import { PRODUCT_IMMERSIVE } from 'Client/cms/toolkit/constants';
import { buildProductArgs, buildCruiseArgs } from 'Utils/graphql';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_PRODUCT_IMMERSIVE } from 'Utils/request/requestDictionary';
import { addTranslationKeys } from 'Src/i18n';

type CMSProps = {
  cruiseDatesPlaceholder: string,
  dateFormat: string,
  fromToPlaceholder: string,
  id: string,
  resortId: string,
  tourDurationPlaceholder: string,
};

type GQLProps = {
  config: CMSContent,
  cruise: {
    fromToDestination: string,
  },
  media: {
    photos: Array<{ url: string }>,
    videos: Array<{ url: string, thumbnailUrl: string }>,
    videos360: Array<{ url: string, thumbnailUrl: string }>,
  },
  resort: Resort,
  socialPictures: Array<SocialPicture>,
};

export const productImmersiveResolver = {
  name: PRODUCT_IMMERSIVE,
  resolve: (
    appContext: AppContext,
    props: CMSProps,
    pageContext: PageContext,
    location: ProductRouterLocation,
  ): Promise<GQLProps> => {
    const {
      resortId: productId,
      tourDurationPlaceholder = '',
      cruiseDatesPlaceholder = '',
      fromToPlaceholder = '',
      dateFormat = '',
    } = props;
    const { urlParams } = location;
    const resortArgs = buildProductArgs(productId, urlParams);
    const cruiseArgs = buildCruiseArgs(urlParams);

    const query = `query {
      config {
        common {
          close
          galleries {
            gallery
            productGallery
          }
          next
          photoTitle
          previous
          socialPicturesTitle
          videoTitle
          video360Title
        }
      }
      cruise(${cruiseArgs}) {
        fromToDestination(message: "${fromToPlaceholder}")
      }
      media(${resortArgs}) {
        photos {url}
        videos {url thumbnailUrl}
        videos360 {url thumbnailUrl}
      }
      resort(${resortArgs}) {
        resortId
        name
        images
        comfort
        comfortLabel
        badgeIcon
        type
        rangeId
        destination {
          country
          area
        }
        duration(message: "${tourDurationPlaceholder}")
        dateRange(message: "${cruiseDatesPlaceholder}", dateFormat: "${dateFormat}")
      }
      socialPictures(${resortArgs}) {
        userName
        imageSmall
        imageLarge
      }
    }`;

    return graphQLClient
      .runQuery(query, appContext, {
        requestName: LINE_PRODUCT_IMMERSIVE,
        strictErrors: false,
      })
      .then(data => {
        addTranslationKeys(data.config);
        return data;
      });
  },
};
